<head><meta name="viewport" content="width=device-width, initial-scale=1.0"></head>
<app-search-component></app-search-component>
<div class="col-xs-12 "  >
  <nav>
    <div class="nav nav-tabs nav-fill w-100" id="nav-tab" role="tablist">
      <a class="nav-item nav-link active" id="nav-schedule-tab" data-toggle="tab" routerLink="/appointments/schedule" role="tab"
         aria-selected="false">SCHEDULE</a>
      <a class="nav-item nav-link" id="nav-checkin-tab" data-toggle="tab"  routerLink="/appointments/Checkin" role="tab"
         aria-selected="false">CHECK-IN</a>
      <a class="nav-item nav-link" id="nav-checkout-tab" data-toggle="tab"  routerLink="/appointments/Checkout" role="tab"
         aria-selected="false">CHECK-OUT</a>
    </div>
  </nav>
  </div>